import {
  getMixpanel,
  handleError,
  pushToDataLayer,
} from '@domain-group/fe-helper';
import { getBaseProps, getUserProps } from '..';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

export const CONTENT_CAROUSEL_ELEMENT_TYPE = 'Widget';
export const CONTENT_CAROUSEL_TYPE = 'Content';

export interface ContentCarouselItem {
  carouselName: string;
  carouselTitle: string;
  carouselSubTitle?: string;
  cardTitle: string;
  itemPosition?: number;
  itemCount?: number;
  selectedArticleId?: string;
  articleFlags?: string;
  selectedArticleTags?: string;
  selectedArticleTitle: string;
  modules?: FaaLandingPageModule[];
}

const trackContentCarouselItem = ({
  carouselName = '',
  carouselTitle,
  carouselSubTitle = '',
  cardTitle,
  itemPosition,
  itemCount,
  selectedArticleId = '',
  articleFlags = '',
  selectedArticleTags = '',
  selectedArticleTitle,
  modules = getVisibleLandingPageModules(),
}: ContentCarouselItem): void => {
  try {
    // Bypass batching: the card opens a new tab, and the hidden-tab beacon flush
    // would otherwise resend the queued batch, showing this event twice.
    getMixpanel().track(
      'Tap Carousel',
      {
        ...getBaseProps(),
        siteSection: 'Agents',
        carouselType: CONTENT_CAROUSEL_TYPE,
        carouselName,
        carouselTitle,
        carouselSubTitle,
        itemPosition,
        itemCount,
        selectedArticleId,
        articleFlags,
        selectedArticleTags,
        selectedArticleTitle,
        modules,
        modulesCount: modules.length,
        ...getUserProps(),
      },
      { send_immediately: true },
    );
  } catch (err) {
    handleError(err);
  }

  pushToDataLayer({
    event: 'cta_driver',
    event_parameters: {
      element_list_name: carouselTitle,
      element_title: cardTitle,
      element_text: selectedArticleTitle,
      element_target_category_primary: 'Content',
      element_target_page_type: selectedArticleId ? 'Article' : 'Category',
      ...(itemPosition === undefined
        ? {}
        : { element_list_position: itemPosition }),
      element_type: CONTENT_CAROUSEL_ELEMENT_TYPE,
    },
  });
};

export default trackContentCarouselItem;
